import React, {ReactNode} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {MessageTypesEnum} from '../../../../libs/shared/core/src/models/api/commonMessageModel';
import {ContactSourcesEnum} from '../../../../libs/shared/core/src/models/api/contactModel';
import {ContactCardPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ContactCardLocationsEnum} from '../../../store/panels/contacts/contactCard/contactCardPanelState';
import {ContactCardHandleItemContainer} from '../details/items/contactCardHandleItemContainer';

/*
 * Types.
 */

export interface RenderHandleOptions {
  handle: string;
  source: ContactSourcesEnum;
  location?: ContactCardLocationsEnum;
  panelId?: ContactCardPanelId;
  shouldHideTitle?: boolean;
}

/*
 * Helpers.
 */

export function renderContactCardHandle(options: RenderHandleOptions) {
  const {source, handle, shouldHideTitle, location, panelId} = options;
  switch (source) {
    case ContactSourcesEnum.EMAIL:
      return (
        <ContactCardHandleItemContainer
          key={handle}
          source={source}
          messageType={MessageTypesEnum.EMAIL}
          handle={handle}
          title={maybeRenderTitle(
            <Trans id="contact-card-details-email-item-title">Email</Trans>,
            Boolean(shouldHideTitle),
          )}
        />
      );
    case ContactSourcesEnum.PHONE:
      return (
        <ContactCardHandleItemContainer
          key={handle}
          source={source}
          messageType={MessageTypesEnum.SMS}
          handle={handle}
          title={maybeRenderTitle(
            <Trans id="contact-card-details-phone-item-title">Phone</Trans>,
            Boolean(shouldHideTitle),
          )}
          location={location}
          panelId={panelId}
        />
      );
    case ContactSourcesEnum.TWITTER:
      return (
        <ContactCardHandleItemContainer
          key={handle}
          source={source}
          messageType={MessageTypesEnum.TWEET}
          handle={handle}
          title={maybeRenderTitle(
            <Trans id="contact-card-details-twitter-item-title">Twitter</Trans>,
            Boolean(shouldHideTitle),
          )}
        />
      );
    case ContactSourcesEnum.TWITTER_DM:
      return (
        <ContactCardHandleItemContainer
          key={handle}
          source={source}
          messageType={MessageTypesEnum.TWEET_DM}
          handle={handle}
          title={maybeRenderTitle(
            <Trans id="contact-card-details-twitter-dm-item-title">Twitter</Trans>,
            Boolean(shouldHideTitle),
          )}
        />
      );
    case ContactSourcesEnum.CUSTOM:
      return (
        <ContactCardHandleItemContainer
          key={handle}
          source={source}
          messageType={MessageTypesEnum.CUSTOM}
          handle={handle}
          title={maybeRenderTitle(
            <Trans id="contact-card-details-custom-item-title">Custom</Trans>,
            Boolean(shouldHideTitle),
          )}
        />
      );
    case ContactSourcesEnum.FACEBOOK:
      return (
        <ContactCardHandleItemContainer
          key={handle}
          source={source}
          messageType={MessageTypesEnum.FACEBOOK}
          handle={handle}
          title={maybeRenderTitle(
            <Trans id="contact-card-details-facebook-item-title">Facebook ID</Trans>,
            Boolean(shouldHideTitle),
          )}
        />
      );
    default:
      return null;
  }
}

function maybeRenderTitle(children: ReactNode, shouldHideTitle: boolean) {
  if (shouldHideTitle) {
    return undefined;
  }
  return children;
}
